
































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader, PickerInput } from '@/components';
import { Button, Dialog, Toast, Popup } from 'vant';
import { FileType } from '@/common/ts/enum';
import { prizeSave } from './api/api';
import * as config from './config';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Register extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  FileType = FileType;
  // 需要传的参数
  bankcard: string = ''; // 银行卡卡号
  openbank: string = ''; // 开户行
  unionpay?: string = ''; // 联户行
  chinaidmain?: any[] = []; // 身份证照片
  chinaidopposite?: any[] = []; // 身份证照片
  phone?: string = ''; // 联系电话
  getOssChinaidmainImagesUrls(result: any) {
    this.chinaidmain = result[0];
  }
  getOssChinaidoppositeImagesUrls(result: any) {
    this.chinaidopposite = result[0];
  }
  enterSave() {
    if (!this.bankcard) {
      Toast.fail('请输入银行卡卡号');
      return false;
    }
    if (!this.openbank) {
      Toast.fail('请输入开户行');
      return false;
    }
    if (!this.unionpay) {
      Toast.fail('请输入联行号');
      return false;
    }
    if (this.chinaidmain && this.chinaidmain.length <= 0) {
      Toast.fail('请上传身份证照片（正面）照片');
      return false;
    }
    if (this.chinaidopposite && this.chinaidopposite.length <= 0) {
      Toast.fail('请上传身份证照片（反面）照片');
      return false;
    }
    prizeSave(this.options.voteName, {
      bankcard: this.bankcard,
      openbank: this.openbank,
      unionpay: this.unionpay,
      chinaidmain: this.chinaidmain,
      chinaidopposite: this.chinaidopposite,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 500) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，工作人员会尽快为您办理！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.push({ path: './RankingList' });
      }, 3000);
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
